export default __webpack_public_path__ + "static/media/simpleMachining.b0cde529.webp";